import { ArrowUp, Plus, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

import { Logo } from "@/components/common/Logo";
import { Button } from "@/components/ui";
import { ROUTES } from "@/constants/routes";
import { useGetMe } from "@/services/api-hooks/user";
import { useAuthStore } from "@/store/auth.store";

import { NavbarMenu } from "./components/NavbarMenu";

export function Navbar() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const { data: user } = useGetMe();
  const isSubscribed = user?.is_subscribed;

  return (
    <nav className="sticky top-0 z-50 border-zinc-200 border-b bg-white/80 backdrop-blur-lg">
      <div className="mx-auto flex h-14 max-w-6xl items-center justify-between px-4 sm:h-16 sm:px-6">
        <Link to={ROUTES.HOME}>
          <Logo variant="dark" />
        </Link>

        {isAuthenticated ? (
          <div className="flex items-center gap-2">
            <Button asChild className="gap-1.5 px-3">
              <Link to={ROUTES.CREATE}>
                <Plus />
                New
              </Link>
            </Button>

            {!isSubscribed && (
              <Button
                asChild
                variant="outline"
                className="gap-1.5 border-primary px-3 text-primary md:hover:bg-background"
              >
                <Link to={ROUTES.PAYWALL("default")}>
                  <ArrowUp />
                  Upgrade
                </Link>
              </Button>
            )}

            <NavbarMenu />
          </div>
        ) : (
          <div className="flex items-center gap-2">
            <Button asChild variant="ghost" className="px-3 text-zinc-700 sm:px-4">
              <Link to={ROUTES.LOGIN}>Log in</Link>
            </Button>
            <Button asChild className="px-3 sm:px-4">
              <Link to={ROUTES.SIGNUP}>
                <Sparkles className="h-4 w-4" />
                <span className="hidden sm:inline">Get Started</span>
                <span className="sm:hidden">Sign up</span>
              </Link>
            </Button>
          </div>
        )}
      </div>
    </nav>
  );
}
